import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Tab {
    activeTab: string;
}

interface TabState {
    value: Tab;
    setPreviousPath: string
}

const initialState: TabState = {
    value :{
        activeTab: '',
    },
    setPreviousPath :''
};



const setActiveTabSlice = createSlice({
  name: "setActiveTab",
  initialState: initialState,
  reducers: {
    setActiveTab: (state,  action: PayloadAction<string>) => {
      state.value.activeTab = action.payload;
    },
    setPreviousPath: (state, action: PayloadAction<string>) => {
      state.setPreviousPath = action.payload;
    },
  }
});

export const { setActiveTab, setPreviousPath } = setActiveTabSlice.actions;

export default setActiveTabSlice.reducer;